/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Text } from '@radix-ui/themes';

import { styled } from 'fierry/react';


const TitleText = styled(Text)`

  color: var(--gray-12);

  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;


export default (props) =>
(
  <TitleText {...props} size = '3' />
);
